<template lang="html">
  <div class="pet-review row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-12">
      <div class="" style="display: none">
        <img src="../../assets/img/icons/1-bqs.svg">
        <img src="../../assets/img/icons/2-vaksina.svg">
        <img src="../../assets/img/icons/3-ekto.svg">
        <img src="../../assets/img/icons/4-ehino.svg">
        <img src="../../assets/img/icons/5-pr.svg">
        <img src="../../assets/img/icons/6-izsledwane.svg">
        <img src="../../assets/img/icons/7-pristap.svg">
        <img src="../../assets/img/icons/8-operaciq.svg">
        <img src="../../assets/img/icons/9-legalizaciq.svg">
        <img src="../../assets/img/icons/10-drugi.svg">
      </div>
      <div class=" pet-review-container">
        <div class="row">
          <div class="col-md-12 review-header" v-if="role == 'owner'">
            <div class="row">
              <div class="col-md-6 text-left">
                <div class="row">
                  <div class="col-md-6">
                    <div class="pet-image pet-thumb">
                      <img v-if="pet.petAvatar" class="img-responsive img-circle" v-bind:src="pet.petAvatar">
                      <img v-else class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Pet Image">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="pet-name review-header-text">{{pet.petName}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-left">
                <div class="pet-indetification review-header-text">
                  {{translation.petProfile.identNumber + ': ' + pet.passportId}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 filter-container">
            <div class="row">
              <div class="col-md-7 col-xs-9">
                <div class="row">
                  <div class="col-md-3 col-xs-3 text-filter">
                    <span>{{translation.petReview.filterBy}}</span>
                  </div>
                  <div class="col-md-9 col-xs-12 col-sm-12 text-left">
                    <select v-model="filter">
                      <option v-for="filter in filters" :value="filter.value">
                        {{filter.text}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-5 hidden-sm hidden-xs">
                <button class="add-review-button" @click="showPetAddModal(pet.petName)" :disabled='addButton'><img src="../../assets/img/icons/add-pet-plus.svg" alt="Add pet review image"/>
                  <div class="show-add-text">
                    {{translation.header.add}}
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12 hidden-sm hidden-xs review-headers text-left">
            <div class="col-md-3">
              {{translation.petReview.titleReview}}
            </div>
            <div class="col-md-2">
              {{translation.petReview.date}}
            </div>
            <div class="col-md-2">
              {{translation.petReview.remaindingOn}}
            </div>
            <div class="col-md-3">
              {{translation.petReview.adddByTitle}}
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="col-md-12 hidden-sm hidden-xs all-review-container">
            <div class="row" v-if='petReviews.length'>
              <div class="col-md-12 single-review" v-for='(review,idx) in petReviews' v-show="filter == null || filter == review.reviewOptions">
                <div class="row text-left">
                  <div :class="{addByDoctor: review.editBy == 'doctor'}">
                    <div class="col-md-3">
                      <span v-for='option in options' v-if="option.value == review.reviewOptions">
                        <span><img class="img-responsive" :src="option.iconSrc" :alt="option.text" /></span><span> {{option.text}}</span>
                      </span>
                      <span v-if="review.otherTheme"> - {{review.otherTheme}}</span>
                    </div>
                    <div class="col-md-2">
                      <span> {{review.vaccinationDate}}</span>
                    </div>
                    <div class="col-md-2">
                      <span v-if="review.validUntil">{{review.validUntil}}</span>
                    </div>
                    <div class="col-md-3">
                      <div v-if="review.addedBy == 'owner' && review.editBy == 'owner'">
                        {{translation.petReview.owner}}
                      </div>
                      <div v-else-if="review.editBy == 'doctor'">
                        {{translation.petReview.addByDoctor + review.addedBy}}
                      </div>
                      <div v-else></div>
                    </div>
                    <div class="col-md-2">
                      <div class="row">
                        <div class="col-md-4 reviews-icons">
                          <div v-if="review.addedBy == 'owner' && review.editBy == 'owner' && role == 'owner'">
                            <img src="../../assets/img/icons/pet-review-delete.svg" @click="showModal(review,idx)" alt="Delete Pet Review">
                          </div>
                          <div v-else-if="review.editBy == 'doctor' && role == 'doctor'">
                            <img src="../../assets/img/icons/pet-review-delete.svg" @click="showModal(review,idx)" alt="Delete Pet Review">
                          </div>
                        </div>
                        <div class="col-md-4 reviews-icons">
                          <div>
                            <img src="../../assets/img/icons/pet-review-comment.svg" @click="showComment(review,idx)" alt="Comment Pet Review">
                          </div>
                        </div>
                        <div class="col-md-4 reviews-icons" v-if="review.pet_review_image">
                          <div class="">
                            <img src="../../assets/img/icons/photo-icon.svg" @click="showPetReviewImage(review,idx)" alt="Photo Icon">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="" v-else-if="addButton != true && !doctorAutorization">
              <h3>{{translation.petReview.noReviews + petName}}</h3>
              <h3>{{translation.petReview.userAddReview}}</h3>
              <button class="add-review-button-big" @click="showPetAddModal(pet.petName)"> <img src="../../assets/img/icons/add-pet-plus.svg" alt="Add pet review image" /></button>
            </div>
            <div v-show="addButton && !doctorAutorization">
              <h3>{{translation.serverError.notPayed}}</h3>
              <h3>{{translation.serverError.howToPay}}<router-link :to="{name: homePage, params:{ lang: lang}}">{{translation.serverError.homePageLink}}</router-link></h3>
            </div>
            <div v-show="doctorAutorization">
              <h3>{{translation.serverError.doctorAutorization}}</h3>
            </div>
          </div>
          <div class="col-md-12 hidden-md hidden-lg all-review-container">
            <div class="row" v-if='petReviews.length'>
              <div class="col-md-12 single-review" v-for='(review,idx) in petReviews' v-show="filter == null || filter == review.reviewOptions">
                <div class="row text-left" @click='toggle(review,idx)'>
                  <div :class="{addByDoctor: review.editBy == 'doctor'}">
                    <div class="col-xs-10">
                      <span v-for='option in options' v-if="option.value == review.reviewOptions">
                        <span><img class="img-responsive" :src="option.iconSrc" :alt="option.text" /></span><span> {{option.text}}</span>
                      </span>
                      <span v-if="review.otherTheme"> - {{review.otherTheme}}</span>
                    </div>
                    <div class="col-xs-2 text-right">
                      <img v-if="isSelected == idx" src="../../assets/img/icons/blue-arrow-mobile.svg" alt="arrow">
                      <img v-else src="../../assets/img/icons/grey-arrow-mobile.svg" alt="arrow">
                    </div>
                    <div class="col-xs-12 text-left" v-show="isSelected == idx && isSelected != null">
                      <div class="row">
                        <div class="col-sm-3">
                          {{translation.petReview.date}}
                        </div>
                        <div class="col-sm-9 blue-text">
                          <span v-if="review.vaccinationDate">{{review.vaccinationDate}}</span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          {{translation.petReview.tiitleNotificationDateMobile}}
                        </div>
                        <div class="col-sm-8 blue-text">
                          <span v-if="review.validUntil">{{review.validUntil}}</span>
                        </div>
                      </div>
                      <div class="row text-center mobile-icons">
                        <div class="col-xs-4">
                          <div v-if="review.addedBy == 'owner' && review.editBy == 'owner' && role == 'owner'">
                            <img src="../../assets/img/icons/pet-review-delete.svg" @click="showModal(review,idx)" alt="Delete Pet Review">
                          </div>
                          <div v-else-if="review.editBy == 'doctor' && role == 'doctor'">
                            <img src="../../assets/img/icons/pet-review-delete.svg" @click="showModal(review,idx)" alt="Delete Pet Review">
                          </div>
                        </div>
                        <div class="col-xs-4">
                          <img src="../../assets/img/icons/pet-review-comment.svg" @click="showComment(review,idx)" alt="Comment Pet Review">
                        </div>
                        <div class="col-xs-4 reviews-icons" v-if="review.pet_review_image">
                          <div class="">
                            <img src="../../assets/img/icons/photo-icon.svg" @click="showPetReviewImage(review,idx)" alt="Photo Icon">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="" v-else-if="addButton != true && !doctorAutorization">
              <h3>{{translation.petReview.noReviews + petName}}</h3>
              <button class="add-review-button-big" @click="showPetAddModal(pet.petName)"> <img src="../../assets/img/icons/add-pet-plus.svg" alt="Add pet review image" /></button>
            </div>
            <div class="no-reviews" v-else-if="addButton != true">
              <h3>{{translation.petReview.noReviews + petName}}</h3>
              <p>{{translation.petReview.userAddReview}}</p>
              <button class="add-review-button-big" @click="showPetAddModal(pet.petName)"> <img src="../../assets/img/icons/add-pet-plus.svg" alt="Add pet review image" /></button>
            </div>
            <div v-show="addButton && !doctorAutorization">
              <h3>{{translation.serverError.notPayed}}</h3>
              <h3>{{translation.serverError.howToPay}}<router-link :to="{name: homePage, params:{ lang: lang}}">{{translation.serverError.homePageLink}}</router-link></h3>
            </div>
            <div v-show="doctorAutorization">
              <h3>{{translation.serverError.doctorAutorization}}</h3>
            </div>
            <div class="add-pet-mobile-button">
              <button class="add-review-button" @click="showPetAddModal(pet.petName)" :disabled='addButton'><img src="../../assets/img/icons/add-pet-plus.svg" alt="Add pet review image" /></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if='showReviewModal' class="modal text-left">
      <div class="modal-content modal-small" >
        <div class="modal-header">
          <h3>{{translation.modalText.modalHeader}}</h3>
          <span class="close-modal" @click="hideModal">&times;</span>
        </div>
        <div class="modal-body modal-body-small">
          {{translation.modalText.deletePetReview + petName}}
        </div>
        <div class="modal-footer">
          <button class="modal-button-add" @click="deletePetReview">{{translation.petProfile.delete}}</button>
          <button class="btn close-modal-button" @click="hideModal">{{translation.button.remove}}</button>
        </div>
      </div>
    </div>
    <div v-if='showCommentModal' class="modal text-left">
      <div class="modal-content" >
        <div class="modal-header">
          <h3>
            <span v-for='option in options' v-if="option.value == modalComment.reviewOptions">
            <span><img class="img-responsive" :src="option.iconSrc" :alt="option.text" /></span><span> {{option.text}}<span v-if="modalComment.otherTheme"> - {{modalComment.otherTheme}}</span>{{translation.userNotification.of + modalComment.petName + ' - ' + modalComment.vaccinationDate}}</span>
          </span>
        </h3>
          <span class="close-modal" @click="hideComent">&times;</span>
        </div>
        <div class="modal-body">
          <div class="row text-left">
            <div class="col-md-4">
              <div v-if="modalComment.manufacturer">
                {{translation.petReview.manufacturer + ' - ' + modalComment.manufacturer}}
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="modalComment.nameOfVaccine">
                {{translation.petReview.nameOfProduct + ' - ' + modalComment.nameOfVaccine}}
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="modalComment.batchNumber">
                {{translation.petReview.batchNumber + ' - ' + modalComment.batchNumber}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3>{{translation.petReview.comment}}</h3>
              <div>
                {{modalComment.comment}}
              </div>
            </div>
            <div class="col-md-12" v-if="modalComment.pet_videos">
              <p>
                <video :src="modalComment.pet_videos" controls></video>
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn close-modal-button" @click="hideComent">{{translation.button.remove}}</button>
        </div>
      </div>
    </div>
    <div v-if='addPetReviewModal' class="modal text-left">
      <div class="modal-content" >
        <div class="modal-header">
          <h3>
            {{translation.modals.petReview + petName}}
          </h3>
          <span class="close-modal" @click="hidePetReviewModal">&times;</span>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addReview" class="col-md-12 text-left" novalidate>
            <select v-model="petReview.reviewOptions" @change="cleareForm">
              <option v-for="option in options" :value="option.value">
                {{option.text}}
              </option>
            </select>
            <div class="row" v-if="petReview.reviewOptions == 'VAR' || petReview.reviewOptions == 'OV'">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="manufacturer" v-model="petReview.manufacturer" :placeholder="translation.petReview.manufacturer">
                  <label for="manufacturer">{{translation.petReview.manufacturer}}</label>
                </div>
                <div class="form-group">
                  <input type="text" name="nameOfVaccine" v-model="petReview.nameOfVaccine" :placeholder="translation.petReview.nameOfVaccine">
                  <label for="nameOfVaccine">{{translation.petReview.nameOfVaccine}}</label>
                </div>
                <div class="form-group">
                  <input type="text" name="batchNumber" v-model="petReview.batchNumber" :placeholder="translation.petReview.batchNumber">
                  <label for="batchNumber">{{translation.petReview.batchNumber}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.vaccinationDate">
                  <label for="vaccinationDate">{{translation.petReview.vaccinationDate}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
              <div class="col-md-12">
                <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                </textarea>
                <label for="comment">{{translation.petReview.comment}}</label>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'TT' || petReview.reviewOptions == 'ET'">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="manufacturer" v-model="petReview.manufacturer" :placeholder="translation.petReview.manufacturer">
                  <label for="manufacturer">{{translation.petReview.manufacturer}}</label>
                </div>
                <div class="form-group">
                  <input type="text" name="nameOfVaccine" v-model="petReview.nameOfVaccine" :placeholder="translation.petReview.nameOfProduct">
                  <label for="nameOfVaccine">{{translation.petReview.nameOfProduct}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
              <div class="col-md-12">
                <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                </textarea>
                <label for="comment">{{translation.petReview.comment}}</label>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'anAttack'">
              <div class="col-md-12">
                <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                </textarea>
                <label for="comment">{{translation.petReview.comment}}</label>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <label class="btn btn-success petReviewVideo-class" for="petReviewVideo" accept="video/*" @change="videoMessage">
                    <input id="petReviewVideo" type="file"  style="display:none;">
                    {{translation.button.uploadVideo}}
                </label>
                <!-- <div>
                  <progress max="100" :value="uploadPercentage"></progress><span>{{uploadPercentage}} %</span>
                </div> -->
                <div class="text-success" v-show="uploadVideoMessage">{{uploadVideoMessage}}</div>
                <div class="text-danger" v-show="uploadErrorVideoMessage">{{uploadErrorVideoMessage}}</div>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'operation'">
              <div class="col-md-6">
                <div class="form-group">
                  <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                  </textarea>
                  <label for="comment">{{translation.petReview.comment}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'legalisation'">
              <div class="col-md-6">
                <div class="form-group">
                  <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.legalisationBody">
                  </textarea>
                  <label for="comment">{{translation.petReview.legalisationBody}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'Others'">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="otherTheme" v-model="petReview.otherTheme" :placeholder="translation.contact.theme">
                  <label for="otherTheme">{{translation.contact.theme}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
              <div class="col-md-12">
                <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                </textarea>
                <label for="comment">{{translation.petReview.comment}}</label>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'PR'">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
              </div>
              <div class="col-md-6">

              </div>
              <div class="col-md-12">
                <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                </textarea>
                <label for="comment">{{translation.petReview.comment}}</label>
              </div>
            </div>
            <div class="row" v-if="petReview.reviewOptions == 'IZ'">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="otherTheme" v-model="petReview.otherTheme" :placeholder="translation.petReview.izText">
                  <label for="otherTheme">{{translation.contact.theme}}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                  <label for="vaccinationDate">{{translation.petReview.date}}</label>
                </div>
                <div class="form-group">
                  <select name="validUntil" v-model="petReview.validUntil">
                    <option v-for="day in days" :value="day.value">
                      {{day.text}}
                    </option>
                  </select>
                  <label for="validUntil">{{translation.petReview.validUntil}}</label>
                </div>
              </div>
              <div class="col-md-12 pet-image-modal">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12 text-center">
                      <p v-show="upload" class="text-success">{{translation.petReview.uploadImageSuccess}}</p>
                      <p v-show="noUpload" class="text-danger">{{translation.serverError.serverError}}</p>
                    </div>
                    <div class="col-sm-6">
                      <p>{{translation.petReview.imageFromIz}}:</p>
                    </div>
                    <div class="col-sm-6">
                      <label class="btn btn-success add-doctor-image" for="add-pet-review-image" accept="image/*" @change='imageMessage'>
                          <input id="add-pet-review-image" type="file"  style="display:none;">
                          {{translation.button.addImage}}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                </textarea>
                <label for="comment">{{translation.petReview.comment}}</label>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">

          <button type="submit" class=" modal-button-add" @click='addReview'>{{translation.button.add}}</button>
          <button class="modal-button-remove close-modal-button close-modal"  @click="hidePetReviewModal">{{translation.button.remove}}</button>
        </div>
      </div>
    </div>
    <div v-if='showReviewImageModal' class="modal text-left">
      <div class="modal-content modal-image" >
        <div class="modal-header">
          <h3>
            <span v-for='option in options' v-if="option.value == modalComment.reviewOptions">
            <span>{{option.text}}<span v-if="modalComment.otherTheme"> - {{modalComment.otherTheme}}</span>{{translation.userNotification.of + modalComment.petName + ' - ' + modalComment.vaccinationDate}}</span>
          </span>
        </h3>
          <span class="close-modal" @click="hideReviewImageModal">&times;</span>
        </div>
        <div class="modal-body text-center">
          <div class="row">
            <div class="col-md-12">
              <img class="img-responsive" :src="modalComment.pet_review_image" alt="Pet image">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn close-modal-button" @click="hideReviewImageModal">{{translation.button.remove}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PetReviewModal',
  props: ['petId'],
  data(){
    return {
      translation: null,
      isActive: false,
      petName: localStorage.getItem('petName'),
      lang: window.lang,
      pet: '',
      showReviewModal: false,
      showCommentModal: false,
      addPetReviewModal: false,
      showReviewImageModal: false,
      doctorAutorization: false,
      modalComment: '',
      addButton: false,
      isSelected: null,
      reviewModal: null,
      uploadPercentage: 0,
      upload: false,
      noUpload: false,
      uploadVideoMessage: '',
      uploadErrorVideoMessage: '',
      loader: false,
      wrongFormat : false,
      deleteReview: {
        petReviewId: null
      },
      petReview: {
        reviewOptions: 'VAR',
        manufacturer: '',
        nameOfVaccine: '',
        batchNumber: '',
        vaccinationDate: new Date().toISOString().slice(0,10),
        validUntil: '0',
        comment: '',
        otherTheme: '',
        addedBy: '',
        editBy: ''
      },
      filter: null,
      petReviews: [],
      response: {
        petId: ''
      },
      options: message.petReview.options,
      filters: message.petReview.filters,
      days: message.petReview.days,
      doctorPermisson: localStorage.getItem('doctorLoggedIn'),
      ids:[],
      role: null,
      homePage: ''
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.petReview.reviews;
    this.getPet();
    this.getIds();
    this.addPetReviews();
    this.$bus.$on('addReview', () => {
      this.addPetReviews();
    });
    if (localStorage.getItem('userLoggedIn')) {
      this.role = 'owner';
    }else {
      this.role = 'doctor';
    }
    if (this.role == 'owner') {
      this.homePage = 'user-home-page';
    } else if(this.role == 'doctor'){
      this.homePage = 'doctor-home';
    }
  },
  watch: {
    petId: function () {
      this.getPet();
      this.addPetReviews()
    }
  },
  methods: {
    getPet: function(){
      this.loader = true;
      var formData = this.toFormData({petId: this.$props.petId});
      var self = this;
      axios.post('view-pet-profile', formData)
      .then(function (response) {
        self.loader = false;
        if (response.data.result) {
          if (response.data.result.noAccess) {
            self.$router.push({ name: self.homePage, params: { lang: window.lang } })
          }  else {
            self.pet = response.data.result;
            localStorage.setItem('petName', self.pet.petName );
            self.petName = self.pet.petName;
            self.getPassport();
            if (response.data.result.petReview) {
              self.pet.petReview = '../../..' + response.data.result.petReview;
            }
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
    },
    showPetAddModal(name) {
      this.petName = localStorage.getItem('petName');
      this.addPetReviewModal = true;
      this.getIds();
      if (this.filter != null) {
        this.petReview.reviewOptions = this.filter;
      }else{
        this.petReview.reviewOptions = "VAR";
      }
    },
    hidePetReviewModal() {
      this.addPetReviewModal = false;
      this.petReview = {
        reviewOptions: 'VAR',
        manufacturer: '',
        nameOfVaccine: '',
        batchNumber: '',
        vaccinationDate: new Date().toISOString().slice(0,10),
        validUntil: '0',
        comment: '',
        otherTheme: '',
        addedBy: '',
        editBy: '',
      }
    },
    showModal(review,idx) {
      this.deleteReview.petReviewId = review.petReviewId;
      this.petName = review.petName;
      this.showReviewModal = true;
    },
    showComment(review,idx) {
      this.modalComment = review;
      this.showCommentModal = true;
    },
    showPetReviewImage(review,idx) {
      this.modalComment = review;
      this.showReviewImageModal = true;
    },
    hideComent(){
      this.showCommentModal = false;
    },
    hideModal() {
      this.showReviewModal = false;
    },
    hideReviewImageModal(){
      this.showReviewImageModal = false;
    },
    addReview(){
      this.loader = true;
      if ( localStorage.getItem('userLoggedIn') == true
        || localStorage.getItem('userLoggedIn') == 'true') {
          this.petReview.addedBy = 'owner';
          this.petReview.editBy = 'owner';
      }else {
        this.petReview.addedBy = 'doctor';
        this.petReview.editBy = 'doctor';
      }
      var startDate = (new Date(this.petReview.vaccinationDate)).getTime();
      var afterDay = this.petReview.validUntil * 24*60*60*1000;
      var finalDate = new Date(startDate + afterDay);
      this.petReview.validUntil = finalDate.toISOString().slice(0,10);
      var video = document.getElementById('petReviewVideo');
      var reviewImage = document.getElementById('add-pet-review-image');
      var formData = this.toFormData(this.petReview);
      formData.append('ownerId', this.ids.ownerId);
      formData.append('petId', this.ids.petId);
      formData.append('petName', this.petName);
      var self = this;
      const reader = new FileReader();
      if (video != undefined && video != null) {
        video = document.getElementById('petReviewVideo').files[0];
        formData.append('createFolder', 'videos')
        if (video != undefined && video != null) {
          if (video.name.match(/.(m4v|avi|mpg|mp4|webm)$/i)) {
            formData.append('videos[]', video)
          }else{
            self.uploadErrorVideoMessage = self.translation.errors.videoError;
          }
        }
      }else if (reviewImage != undefined && reviewImage !=null) {
        reviewImage = document.getElementById('add-pet-review-image').files[0];
        formData.append('createFolder', 'review-image');
        if (reviewImage != undefined && reviewImage != null) {
          if (reviewImage.name.match(/.(jpg|jpeg|png|gif)$/i)) {
            formData.append('images[]', reviewImage)
          }else{
            self.wrongFormat = true;
          }
        }
      }
      else {
        formData.append('createFolder', '')
      }
      axios.post('add-pet-review', formData)
      .then(function(response){
        self.loader = false;
        self.petReview = {
          userId: '',
          reviewOptions: 'VAR',
          manufacturer: '',
          nameOfVaccine: '',
          batchNumber: '',
          vaccinationDate: new Date().toISOString().slice(0,10),
          validUntil: '0',
          comment: '',
          petName: '',
          otherTheme: '',
          addedBy: ''
        }
        self.$bus.$emit('addReview', true)
        self.hidePetReviewModal();
      })
      .catch(err => err)
    },
    getIds(){
      this.loader = true;
      var formData = this.toFormData({petId: this.$props.petId});
      var self = this;
      axios.post('get-ids', formData)
      .then(function(response){
        self.loader = false;
        self.ids = response.data.result;
      })
      .catch(err => err)
    },
    videoMessage(){
      var video = document.getElementById('petReviewVideo');
      if (video != undefined && video != null) {
        video = document.getElementById('petReviewVideo').files[0]
        if (video != undefined && video != null) {
          if (video.name.match(/.(m4v|avi|mpg|mp4|webm)$/i)) {
            this.uploadErrorVideoMessage = "";
            this.uploadVideoMessage = this.translation.petReview.uploaded;
          }else{
            this.uploadVideoMessage = "";
            this.uploadErrorVideoMessage = this.translation.errors.videoError;
          }
        }
      }
    },
    imageMessage(){
        var reviewImage = document.getElementById('add-pet-review-image');
       if (reviewImage != undefined && reviewImage !=null) {
        reviewImage = document.getElementById('add-pet-review-image').files[0];
        if (reviewImage != undefined && reviewImage != null) {
          if (reviewImage.name.match(/.(jpg|jpeg|png|gif)$/i)) {
            this.upload = true;
            this.noUpload = false;
          }else{
            this.upload = false;
            this.noUpload = true;
          }
        }
      }
    },
    addPetReviews(){
      //this.response.petId = this.$route.params.petId;
      this.loader = true;
      this.response.petId = this.$props.petId;
      this.petReviews = [];
      this.doctorAutorization = false;
      var formData = this.toFormData(this.response);
      var self = this;
      axios.post('get-all-pet-reviews', formData)
      .then(function (response) {
        self.loader = false;
        if (response.data.result.serverMessage == 'notPayed') {
          self.addButton = true;
          self.petReviews = ''
        }else if (response.data.result.serverMessage == 'isNotFvoriteDoctor') {
          self.addButton = true;
          self.doctorAutorization = true;
        }
        else {
          self.petReviews = response.data.result
          self.addButton = false;
        }

      })
      .catch(function (error) {
        console.log(error);
      })
    },
    deletePetReview(){
      this.loader = true;
      var formData = this.toFormData(this.deleteReview);
      var self = this;
      axios.post('delete-pet-review', formData)
      .then(function (response) {
        self.loader = false;
        self.hideModal()
        self.isSelected = null
        self.addPetReviews()
      })
      .catch(function (error) {
        console.log(error);
      })
    },
    cleareForm(){
        this.petReview.manufacturer = '';
        this.petReview.nameOfVaccine = '';
        this.petReview.batchNumber = '';
        this.petReview.vaccinationDate = new Date().toISOString().slice(0,10);
        this.petReview.validUntil = '0';
        this.petReview.comment = '';
        this.petReview.otherTheme = '';
        this.uploadPercentage = 0;
        this.uploadVideoMessage = '';
        this.uploadErrorVideoMessage = '';
    },
    toggle(review,idx) {
      if(this.isSelected != idx){
        this.isSelected = idx
      }else{
      	this.isSelected = null
      }
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style>
  /* new style */

  .pet-review .pet-review-container{
    margin-top: 14em;
    -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
    border-radius: .75em;
    margin-bottom: 5em;
  }
  .pet-review .review-header{
    background: #3057b0;
    padding: 3em;
    position: relative;
    border-top-left-radius: .75em;
    border-top-right-radius: .75em;
  }
  .review-header .pet-image img{
    max-width: 10em;
    width: 10em;
    height: 10em;
    display: inline-block;
    border: 4px solid #3057b0;
    position: absolute;
    top: -9em;
  }
  .pet-review .review-header .review-header-text{
    color: #fff;
    font-weight: bold;
    font-size: 1.2em;
    margin-top: 1em;
  }
  .pet-review .modal-header span img {
    max-width: 3em;
  }
  .pet-review .filter-container{
    padding: 1em;
    padding-top: 2em;
    padding-bottom: 0;
    background: #fff;
  }
  .pet-review .filter-container .text-filter{
    font-weight: bold;
    text-align: right;
  }
.modal-image {
    width: 100%;
  }
  .pet-review  .add-review-button {
    width: 6em;
    background: transparent;
    border: none;
    position: absolute;
    top: .9em;
    right: 2em;
    z-index: 3;
  }
  .pet-review .add-review-button-big{
    background: transparent;
    border: none;
    width: 5em;
  }
  .show-add-text{
    display: none;
  }
  video {
    width: 100%;
    height: 100%;
  }
  .reviews-icons div:hover{
    background: #eee;
    text-align: center;
    border-radius: 1em;
  }
  .add-review-button img:hover + .show-add-text{
      display: block;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 1em;
  }
  .single-review img{
    cursor: pointer;
  }
  .single-review span img {
    max-width: 2em;
  }
  .pet-review  .review-headers {
    border-bottom: 1px solid  #707070;
    padding-top: 1em;
    padding-bottom: 1em;
    background: #EEEEEE;
  }
  .pet-review .all-review-container {
    background: #fff;
    border-bottom-left-radius: .75em;
    border-bottom-right-radius: .75em;
  }
  .pet-review .all-review-container .single-review{
    padding-top: 1em;
    padding-bottom: 1em;
    border-bottom: 1px solid  #EEEEEE;
  }
  .pet-review .addByDoctor,.pet-review .blue-text{
    color: #3057b0;
  }
  .add-pet-mobile-button{
    position: fixed;
    bottom: 10em;
    width: 100%;
    text-align: right;
  }
  .close-modal-button{
    margin-left: 1em;
  }
  .form-group{
    position: relative;
    margin-top: 2em;
  }
  #app .pet-review .add-doctor-image,#app .pet-review .petReviewVideo-class {
    display: block;
  }
   .pet-review input[type=text],
   .pet-review input[type=password],
   .pet-review input[type=email],
   .pet-review textarea,
   .pet-review input[type=date],
   .pet-review select
  {
   color: #707070!important;
   background: none!important;
   border: none!important;
   border-radius: 0!important;
   outline: none!important;
   border-bottom: 2px solid #707070!important;
   width: 100%;
   outline: none!important;
   margin-bottom: 2em;
   font-weight: bold;
 }
  .pet-review label {
   display: none;
 }
  .pet-review input[type=text]:focus,
  .pet-review input[type=password]:focus,
  .pet-review input[type=email]:focus,
  .pet-review textarea:focus,
  .pet-review input[type=date]:focus,
  .pet-review select:focus
 {
   border-bottom: 2px solid #3057B0!important;
   outline:0px !important;
   -webkit-appearance:none;
   box-shadow: none !important;
   opacity: 1;
   color: #3057B0!important;
 }
  #app .pet-review input[type=text]:focus + label ,
  #app .pet-review input[type=password]:focus + label,
  #app .pet-review input[type=email]:focus + label,
  #app .pet-review textarea:focus + label,
  #app .pet-review input[type=date]:focus + label,
  #app .pet-review select:focus + label
 {
    display: block;
    position: absolute;
    bottom: 3.5em;
    color: #707070!important;
    font-size: 1em;
    opacity: 1;
 }
 .pet-review textarea:focus + label{
   bottom: -.5em;
 }
 .pet-review ::placeholder {
   color: #707070;
   opacity: .6;
 }
 .pet-review :-ms-input-placeholder {
   color: #707070;
 }
 .pet-review ::-ms-input-placeholder {
   color: #707070;
 }
  .pet-review input[type=text]:focus::-webkit-input-placeholder,
  .pet-review input[type=password]:focus::-webkit-input-placeholder,
  .pet-review input[type=email]:focus::-webkit-input-placeholder
 {
   color:transparent;
 }
  .pet-review input[type=text]::-moz-placeholder
  .pet-review input[type=password]:focus::-moz-placeholder
  .pet-review input[type=email]:focus::-moz-placeholder {
   color:transparent;
 }
  .pet-review input[type=text]:focus::-moz-placeholder
  .pet-review input[type=password]:focus::-moz-placeholder
  .pet-review input[type=email]:focus::-moz-placeholder {
    color:transparent;
  }
   .pet-review input[type=text]:focus::-ms-input-placeholder
   .pet-review input[type=password]:focus::-ms-input-placeholder
   .pet-review input[type=email]:focus::-ms-input-placeholder {
   color:transparent;
 }
 .no-reviews img {
   width: 6em;
 }
 @media (max-width: 1024px) {
   .pet-review .pet-review-container{
     margin-bottom: 11em;
   }

 }
 @media (max-width: 768px) {
   .pet-review .add-review-button{
     position: relative;
     max-width: 8em;
     max-height: 10em;
     top: 0;
   }
   .review-header .pet-image img{
     position: relative;
     border: 2px solid #fff;
     top: 0;
     max-width: 10em;
     max-height: 10em;
     margin-top: 3em;
   }
   .review-header .pet-image{
     text-align: center;
   }
   .review-header .pet-thumb {
     margin: 0 auto;
   }
   .pet-review .review-header .review-header-text{
     text-align: center;
   }
   .pet-review .review-header{
     padding-top:3em;
     padding: 0;
   }
   .review-header .pet-image{
     text-align: center;
   }
   .pet-review .pet-review-container{
     margin-bottom: 16em;
   }
   .pet-review .mobile-icons{
     margin-bottom: 1em;
   }
   .add-pet-mobile-button {
    bottom: 8em;
    text-align: right;
  }
  .pet-review .add-review-button{
    right: 2em;
  }
  .add-pet-mobile-button img {
    width: 4em;
  }
 }

</style>
